import React from 'react';
import { Button, Flex, Heading, Text, View, Well } from '@adobe/react-spectrum';
import Info from '@spectrum-icons/workflow/Info';
import { Text as TypographyText } from 'app/views/components/typography/Text';
import { analytics } from 'app/utils/analytics';
import { storage } from 'app/utils/localStorage';
const dasherize = (value) => value.toLowerCase().replace(/\s+/gi, '-');
const vote = (platform) => storage(`voted-platform-${dasherize(platform.name)}`);
export const Placeholder = (props) => {
    const { platform } = props;
    const [canVote, setCanVote] = React.useState(false);
    const [showToast, setShowToast] = React.useState(false);
    React.useEffect(() => {
        const canVoteOnPlaform = vote(platform).get() !== '1';
        analytics({
            action: 'PublishPlaform',
            label: dasherize(platform.name),
        });
        setCanVote(canVoteOnPlaform);
        setShowToast(canVoteOnPlaform === false);
    }, [platform, setCanVote, setShowToast]);
    const onINeedThis = React.useCallback(() => {
        if (!canVote) {
            return;
        }
        vote(platform).set('1');
        setCanVote(false);
        setShowToast(true);
    }, [canVote, platform, setCanVote]);
    return (React.createElement(Well, null,
        React.createElement(Flex, { direction: "column", gap: "size-200", alignItems: "center" },
            showToast && (React.createElement(View, { position: "absolute", top: "size-10", left: "50%", UNSAFE_style: { transform: 'translate(-50%, 0)' }, padding: "size-75", borderRadius: "small", backgroundColor: "informative" },
                React.createElement(Flex, { direction: "row", gap: "size-75", alignItems: "center" },
                    React.createElement(Info, { size: "XS" }),
                    React.createElement(TypographyText, { size: "S" },
                        "Thanks for voting on ",
                        React.createElement("b", null, platform.name),
                        ".")))),
            React.createElement(Heading, { level: 3 },
                "Publishing to ",
                React.createElement("b", null, platform.name),
                " is not yet available."),
            React.createElement(Text, null, "Vote for it, if you think it should be implemented"),
            React.createElement(Flex, { width: "100%", justifyContent: "center" },
                React.createElement(Button, { variant: "cta", isDisabled: !canVote, onPress: onINeedThis }, "I need this!")))));
};
